import { useTheme } from '@emotion/react';
import { ReactNode } from 'react';
import {
  DEVICE_SCREENS_MAX_STRING,
  DEVICE_SCREENS_MIN_STRING,
} from '../../lib/consts';

export function LabelFeatureListItem({
  text,
  title,
  ...restProps
}: {
  text: string;
  title: string;
}) {
  const theme = useTheme();
  return (
    <li
      css={{
        display: 'block',
        textAlign: 'center',
        marginRight: '6px',
        background: theme.colors.red,
        borderRadius: '2px',
        fontFamily: 'Golos',
        fontStyle: 'normal',
        fontWeight: 500,
        fontSize: '13px',
        lineHeight: '100%',
        color: theme.colors.white,
        padding: '4px 10px',
      }}
      title={title}
      {...restProps}
    >
      {text}
    </li>
  );
}

export function ActionButton({
  children,
  onButtonClick,
  bookButton,
}: {
  children: ReactNode;
  bookButton: boolean;
  onButtonClick: () => void;
}) {
  const theme = useTheme();
  return (
    <button
      onClick={onButtonClick}
      type='button'
      css={{
        fontFamily: 'Golos',
        fontSize: 16,
        fontStyle: 'normal',
        fontWeight: 500,
        lineHeight: '16px',
        letterSpacing: '0em',
        background: theme.colors.buttonRed,
        borderRadius: 4,
        display: 'inline-block',
        padding: 10,
        textAlign: 'center',
        color: theme.colors.white,
        cursor: 'pointer',
        transition: 'all 0.2s ease, box-shadow 0.4s ease',
        '&:hover': {
          boxShadow: `0px 0px 10px 0px ${theme.colors.gradient}`,
        },
        [DEVICE_SCREENS_MAX_STRING.xl]: {
          padding: 9,
          width: '100%',
        },
        ...(bookButton
          ? {
              [DEVICE_SCREENS_MIN_STRING.lg]: {
                width: 200,
              },
            }
          : {}),
        [DEVICE_SCREENS_MAX_STRING.md]: {
          padding: 9,
          width: '100%',
        },
        [DEVICE_SCREENS_MAX_STRING.sm]: {
          padding: 9,
          width: '100%',
        },
      }}
    >
      {children}
    </button>
  );
}

export function ActionLabelItem({
  children,
  ...restProps
}: {
  children: ReactNode;
}) {
  const theme = useTheme();
  return (
    <div
      css={{
        width: '100px',
        height: '34px',
        fontSize: '13px',
        fontWeight: 600,
        color: theme.colors.white,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: '0 4px 10px 0 rgba(0, 0, 0, 0.1)',
      }}
      {...restProps}
    >
      {children}
    </div>
  );
}

export function DescriptionItem({
  children,
  ...restProps
}: {
  children: ReactNode;
}) {
  return (
    <div
      css={{
        display: 'flex',
        lineHeight: '1.3',
        maxHeight: '32px',
        overflow: 'hidden',
        '&>svg': {
          flex: '0 0 auto',
          marginRight: '5px',
        },
      }}
      {...restProps}
    >
      {children}
    </div>
  );
}
